import autocomplete, {
  EventTrigger,
  PreventSubmit,
} from "./autocomplete.ts";

autocomplete.EventTrigger = EventTrigger;
autocomplete.PreventSubmit = PreventSubmit;

export default autocomplete;
